export const az = {
  // Navigation
  documentList: 'Sənəd Siyahısı',
  uploadDocument: 'Sənəd Yüklə',
  contactUs: 'Əlaqə',
  profile: 'Profil',
  login: 'Giriş',
  logout: 'Çıxış',
  aboutUs: 'Haqqımızda',
  apiReference: 'API İstinad',
  integration: 'İnteqrasiya',
  navWorkspace: 'İş sahəsi',
  navResources: 'Resurslar',
  navAccount: 'Hesab',
  navBackToDocuments: 'Sənədlərə qayıt',
  menu: 'Menyu',

  // Common
  version: 'Versiya',
  language: 'Dil',

  // Upload Document
  stepSelectOrganisation: 'Təşkilatı seçin',
  step2: 'İmzalayanlar',
  step3: 'Sənəd Məlumatları',
  step4: 'Yüklə',
  documentTitle: 'Sənəd Başlığı',
  moreDocumentDetails: 'Əlavə məlumat',
  hideDocumentDetails: 'Əlavə məlumatı gizlət',
  uploadOperationIdLabel: 'Əməliyyat / daxili istinad №',
  uploadOperationIdPlaceholder: 'məs. müqavilə №, sifariş №',
  uploadOperationIdHint: 'İstəyə bağlı. Bu imzalama üçün daxili istinadınız.',
  description: 'Təsvir',
  expireDate: 'Bitmə Tarixi',
  summary: 'Xülasə',
  addSigner: 'İmzalayan Əlavə Et',
  addMeAsSigner: 'Məni imzalayan kimi əlavə et',
  alreadyAddedAsSigner: 'Siz artıq imzalayanlar siyahısındasınız.',
  addMeAsSignerNoEmail: 'Profilinizdə e-poçt ünvanı yoxdur.',
  addMeAsSignerPromo: 'Yalnız özünüz imzalayırsınız? Bir toxunuşla məlumatlarınızı doldurun.',
  uploadStepValidationIntro: 'Davam etmək üçün vurğulanmış sahələri doldurun.',
  uploadSignerOptionalSection: 'Əlaqə və ID (istəyə bağlı)',
  uploadFinOptionalHint: 'FIN lazım deyilsə boş buraxın. Doldursanız, 7 simvol olmalıdır.',
  uploadMoreSignerTin: 'VÖEN',
  uploadHideSignerTin: 'VÖEN-i gizlət',
  uploadTinOptionalHint: 'İstəyə bağlı. Doldursanız, VÖEN 10 rəqəm olmalıdır.',
  uploadUnsavedLeaveWarning: 'Yadda saxlanmamış yükləmə məlumatınız var. Səhifəni tərk etmək istəyirsiniz?',
  uploadOptionalSuffix: 'istəyə bağlı',
  signerLabel: 'İmzalayan',
  signerName: 'Ad',
  signerSurname: 'Soyad',
  signerEmail: 'E-poçt',
  signerPhone: 'Telefon',
  signerRole: 'Rol',
  roleSigner: 'İmzalayan',
  roleVisa: 'Viza',
  delete: 'Sil',
  next: 'Növbəti',
  back: 'Geri',
  submit: 'Yüklə',
  cancel: 'Ləğv Et',
  
  // Document List
  documents: 'Sənədlər',
  noDocuments: 'Sənəd yoxdur',
  
  // Profile
  profileTitle: 'Profil',
  name: 'Ad',
  surname: 'Soyad',
  email: 'E-poçt',
  phone: 'Telefon',
  save: 'Saxla',

  // Login/Register
  emailLabel: 'E-poçt',
  password: 'Şifrə',
  rememberMe: 'Məni xatırla',
  forgotPassword: 'Şifrəni unutmusan?',
  username: 'İstifadəçi adı',
  usernameRequired: 'İstifadəçi adı məcburidir',
  invalidUsernameFormat: '2–64 simvol: hərflər, rəqəmlər, nöqtə, alt xətt və ya tire',
  usernameHelper: 'Yalnız hərflər, rəqəmlər, . _ -',
  register: 'Qeydiyyat',
  alreadyHaveAccount: 'Artıq hesabınız var?',
  dontHaveAccount: 'Hesabınız yoxdur?',
  
  // Errors and Messages
  required: 'Bu sahə məcburidir',
  invalidEmail: 'Yanlış e-poçt ünvanı',
  invalidPhone: 'Yanlış telefon nömrəsi',
  nameRequired: 'Ad məcburidir',
  surnameRequired: 'Soyad məcburidir',
  emailRequired: 'E-poçt məcburidir',
  passwordRequired: 'Şifrə məcburidir',
  finRequired: 'FIN kodu məcburidir',
  phoneRequired: 'Telefon nömrəsi məcburidir',
  titleRequired: 'Başlıq məcburidir',
  expireDateRequired: 'Bitmə tarixi məcburidir',
  invalidEmailFormat: 'Yanlış e-poçt formatı',
  invalidPhoneFormat: 'Yanlış telefon nömrəsi formatı',
  invalidPhoneLength: 'Yanlış telefon nömrəsi (rəqəmlər, istəyə bağlı +, 7-15 uzunluq)',
  passwordMinLength: 'Şifrə ən azı 6 simvol olmalıdır',
  passwordsDoNotMatch: 'Şifrələr uyğun gəlmir',
  finCodeLength: 'FIN kodu 7 simvol olmalıdır',
  tinCodeLength: 'VÖEN kodu 10 rəqəm olmalıdır',
  selectOrganisation: 'Zəhmət olmasa təşkilat seçin',
  addAtLeastOneSigner: 'Ən azı bir imzalayan əlavə edin',
  selectFile: 'Zəhmət olmasa yükləmək üçün PDF fayl seçin.',
  selectPdfFile: 'Yalnız PDF fayllarına icazə verilir. Zəhmət olmasa PDF fayl seçin.',
  organisationNotSelected: 'Təşkilat seçilməyib. Zəhmət olmasa geri qayıdın və təşkilat seçin.',
  uploadFailed: 'Sənəd məlumatlarını yükləmək və təqdim etmək mümkün olmadı. Zəhmət olmasa yenidən cəhd edin.',
  loginFailed: 'Giriş uğursuz oldu. Zəhmət olmasa yenidən cəhd edin.',  uploadInProgress: 'Yukləmə davam edir...',
  uploadInProgressHint: 'Sənəd yüklənənə və göndərmə tamamlanana qədər gözləyin.',
  uploading: 'Yüklənir...',

  registrationFailed: 'Qeydiyyat uğursuz oldu. Zəhmət olmasa yenidən cəhd edin.',
  
  // Login/Register Extended
  signIn: 'Daxil Ol',
  signUp: 'Qeydiyyatdan Keç',
  signingIn: 'Daxil olunur...',
  creatingAccount: 'Hesab yaradılır...',
  signInToAccount: 'mySign.az hesabınıza daxil olun',
  createAccount: 'mySign.az hesabınızı yaradın',
  keepMeLoggedIn: 'Məni xatırla',
  emailAddress: 'E-poçt Ünvanı',
  confirmPassword: 'Şifrəni Təsdiqlə',
  phoneNumber: 'Telefon Nömrəsi',
  finCode: 'FIN Kodu',
  finCodeHelper: '7 simvol',

  recoverPasswordTitle: 'Şifrənin bərpası',
  recoverPasswordDescription: 'E-poçt ünvanınızı daxil edin; şifrəni sıfırlamaq üçün keçid göndəriləcək.',
  sendResetLink: 'Sıfırlama keçidi göndər',
  sendingResetLink: 'Göndərilir…',
  resetEmailSent:
    'Bu ünvanda hesab varsa, tezliklə təlimatlar göndəriləcək. Poçt qutusunu yoxlayın.',
  resetPasswordTitle: 'Yeni şifrə',
  resetPasswordDescription: 'Hesabınız üçün yeni şifrə seçin.',
  newPassword: 'Yeni şifrə',
  setNewPassword: 'Şifrəni yenilə',
  updatingPassword: 'Yenilənir…',
  backToSignIn: 'Girişə qayıt',
  invalidResetLink: 'Bu sıfırlama keçidi etibarsızdır və ya natamamdır. Yeni keçid sifariş edin.',
  passwordResetSuccess: 'Şifrəniz yeniləndi. İndi daxil ola bilərsiniz.',
  passwordResetFailed: 'Şifrə yenilənmədi. Keçidin müddəti bitmiş ola bilər.',
  requestPasswordResetFailed: 'Sıfırlama məktubu göndərilmədi. Zəhmət olmasa yenidən cəhd edin.',
  
  confirmEmailTitle: 'E-poçt təsdiqi',
  confirmingEmail: 'E-poçtunuz təsdiqlənir...',
  confirmEmailSuccess: 'E-poçtunuzu təsdiqlədiyiniz üçün təşəkkür edirik. İndi daxil ola bilərsiniz.',
  confirmEmailSuccessHint: 'E-poçtunuz təsdiqləndi. Giriş səhifəsinə yönləndirilirsiniz...',
  confirmEmailFailed: 'E-poçt təsdiqlənmədi. Keçid etibarsız və ya müddəti bitmiş ola bilər.',
  confirmEmailFailedHint: 'Zəhmət olmasa keçidi yenidən sınayın və ya yeni təsdiq məktubu tələb edin.',
  invalidConfirmEmailLink: 'Bu təsdiq keçidi etibarsızdır və ya natamamdır.',

  // Document List Extended
  documentListTitle: 'Sənəd Siyahısı',
  viewAllDocuments: 'Bütün sənədlərinizə baxın',
  noDocumentsFound: 'Sənəd Tapılmadı',
  noDocumentsYet: 'Hələ heç bir sənədiniz yoxdur.',
  pleaseLoginToView: 'Sənədlərinizi görmək üçün daxil olun.',
  failedToLoadDocuments: 'Sənədlər yüklənə bilmədi. Zəhmət olmasa yenidən cəhd edin.',
  title: 'Başlıq',
  expirationDate: 'Bitmə Tarixi',
  status: 'Status',
  actions: 'Əməliyyatlar',
  view: 'Bax',
  operation: 'Əməliyyat',
  unknown: 'Naməlum',
  untitledDocument: 'Adsız Sənəd',
  documentFilters: 'Filtrlər',
  signingStatusFilter: 'İmzalama statusu',
  signStatusAll: 'Hamısı',
  signStatusSigned: 'Tamamlanıb',
  signStatusPending: 'Davam edir',
  createdFromFilter: 'Yaradılma tarixi (dən)',
  expiresBeforeFilter: 'Bitmə tarixi (dək)',
  operationIdFilter: 'Əməliyyat ID',
  operationIdFilterPlaceholder: 'İstəyə bağlı əməliyyat ID',
  applyFilters: 'Filtrləri tətbiq et',
  resetFilters: 'Sıfırla',
  showFilters: 'Filtrləri göstər',
  hideFilters: 'Filtrləri gizlət',

  // Profile Extended
  myProfile: 'Mənim Profilim',
  viewPersonalInfo: 'Şəxsi məlumatlarınıza baxın',
  pleaseLoginToViewProfile: 'Profilinizi görmək üçün daxil olun.',
  failedToLoadProfile: 'Profil yüklənə bilmədi',

  // Footer
  footerText: 'mySign, Azərbaycanda hazırlanıb',
  footerIn: '© 2026',
  footerCopyright: '© 2026 mySign.az. Bütün hüquqlar qorunur.',
  privacyPolicy: 'Məxfilik Siyasəti',
  termsOfService: 'İstifadə şərtləri',
  
  // Upload Document Extended
  review: 'Yoxlama',
  signers: 'İmzalayanlar',
  tinCode: 'VÖEN Kodu',
  selectStorageOrganisation: 'Saxlama Təşkilatı Seçin',
  chooseStorageOrganisation: 'Sənədinizin yüklənəcəyi saxlama təşkilatını seçin.',
  noOrganisationsAvailable: 'Təşkilat mövcud deyil. Zəhmət olmasa dəstək ilə əlaqə saxlayın.',
  endpoint: 'Endpoint',
  selectDocument: 'Sənəd Seçin',
  selectDocumentHint: 'Kompüterinizdən PDF faylı seçin.',
  selectedFile: 'Seçilmiş fayl',
  documentSuccessfullyUploaded: 'Sənəd Uğurla Yükləndi!',
  thankYouMessage: 'Xidmətimizdən istifadə etdiyiniz üçün təşəkkür edirik. Sənədiniz yükləndi və imzalayanlara bildiriş göndəriləcək.',
  goToDocumentList: 'Sənəd siyahısına keç',
  signingLink: 'İmzalama Linki',
  signingLinkCopied: 'Link kopyalandı',
  failedToLoadOrganisations: 'Təşkilatlar yüklənə bilmədi. Zəhmət olmasa səhifəni yeniləyin.',
  
  // Document Page
  document: 'Sənəd',
  validityPeriod: 'Etibarlılıq Müddəti',
  from: 'Başlanğıc',
  to: 'Bitmə',
  organisation: 'Təşkilat',
  notAvailable: 'Mövcud deyil',
  operationId: 'Əməliyyat ID',
  signed: 'İmzalanıb',
  pending: 'Gözləyir',
  documentStatusDone: 'Tamamlandı',
  documentStatusInProgress: 'Davam edir',
  type: 'Növ',
  signingParties: 'İmzalayan Tərəflər',
  signingPartyStatusExpired: 'Müddəti bitib',
  signingPartyStatusRejected: 'Rədd edilib',
  signingPartyStatusReleased: 'Dərkənar edilib',
  finLabel: 'FIN',
  noDocumentInfo: 'Sənəd məlumatı mövcud deyil',
  signWithSima: 'Sima ilə İmzala',
  release: 'Dərkənar et',
  confirm: 'Təsdiq et',
  releaseDialogMessage: 'Siz sənədinizi dərkənar edirsiniz.',
  rejectDialogMessage: 'Siz sənədinizi imtina edirsiniz.',
  releaseDialogConfirm: 'Dərkənar et',
  rejectDialogConfirm: 'İmtina Et',
  failedToUpdateSignStatus: 'İmzalama statusunu yeniləmək mümkün olmadı. Zəhmət olmasa yenidən cəhd edin.',
  reject: 'İmtina Et',
  documentTabDetails: 'Təfərrüatlar',
  documentTabDocument: 'Sənəd',
  documentTabListLabel: 'Sənəd bölmələri',
  documentActions: 'Əməliyyatlar',
  documentActionsExpand: 'Sənəd əməliyyatlarını göstər',
  documentActionsCollapse: 'Sənəd əməliyyatlarını gizlət',
  documentDetailsResize: 'Sənəd təfərrüatları panelini ölçüləndir',
  documentMoreDetails: 'Əlavə məlumat',
  pdfRenderError: 'PDF brauzerdə göstərilə bilmədi. Xarici açmağı sınayın.',
  openPdfInBrowser: 'Brauzerdə aç',
  downloadDocument: 'Yüklə',
  simaSignModalTitle: 'SIMA ilə imzala',
  simaScanQrDesktop: 'SIMA tətbiqi ilə QR kodu skan edin',
  simaScanQrMobile: 'Və ya başqa cihazda SIMA ilə QR kodu skan edin',
  simaOpenSignerApp: 'İmzalama tətbiqini aç',
  simaEnlargeQr: 'QR kodu böyüt',
  simaEnlargedQr: 'Böyüdülmüş QR kod',
  simaTapQrToZoom: 'Böyütmək üçün toxunun',
  simaTapToCloseQr: 'Bağlamaq üçün istənilən yerə toxunun',
  simaSignWaiting: 'İmza gözlənilir…',
  simaSignThanks: 'Təşəkkür edirik. Sənəd imzalanıb.',
  openDocument: 'Sənədi Aç',
  closeDocumentViewer: 'Sənəd Görüntüləyicisini Bağla',
  openDocumentViewer: 'Sənəd Görüntüləyicisini Aç',
  noDocumentLoaded: 'Sənəd önbaxışı yüklənməyib. Serverdən götürmək üçün faylı göstərin.',
  loadDocument: 'Sənədi Yüklə',
  displayFile: 'Faylı göstər',
  rejectDocument: 'Sənədi İmtina Et',
  rejectDocumentReason: 'Zəhmət olmasa bu sənədi imtina etmə səbəbini bildirin.',
  rejectionReason: 'İmtina Etmə Səbəbi',
  documentGUIDNotFound: 'Sənəd GUID tapılmadı.',
  failedToFetchDocumentInfo: 'Sənəd məlumatını əldə etmək mümkün olmadı',
  errorFetchingDocumentInfo: 'Sənəd məlumatını əldə etməkdə xəta. Zəhmət olmasa daha sonra yenidən cəhd edin.',
  signingLinkAccessDenied: 'Bu imzalama linkinə giriş icazəniz yoxdur. Sizə göndərilmiş linki açın və ya düzgün hesabla daxil olun.',
  failedToFetchDocument: 'Sənədi əldə etmək mümkün olmadı',
  errorFetchingDocument: 'Sənədi əldə etməkdə xəta. Zəhmət olmasa daha sonra yenidən cəhd edin.',
  invalidResponseFormat: 'Yanlış cavab formatı',
  failedToInitiateSigning: 'İmzalama prosesini başlatmaq mümkün olmadı',
  documentSigningByOther: 'Sənəd digər tərəf tərəfindən imzalanır. Zəhmət olmasa 5 dəqiqə sonra yenidən cəhd edin.',
  errorInitiatingSigning: 'İmzalama prosesini başlatmaqda xəta. Zəhmət olmasa daha sonra yenidən cəhd edin.',
  signWithUsbToken: 'SIMA USB Açarı ilə İmzala',
  failedToReadCertificates: 'USB açarından sertifikatları oxumaq mümkün olmadı',
  noCertificatesFound: 'Sertifikat tapılmadı. Zəhmət olmasa USB açarınızı qoşun.',
  errorReadingCertificates: 'Sertifikatları oxumaqda xəta. Zəhmət olmasa USB açarınızın qoşulduğundan əmin olun.',
  pleaseSelectCertificate: 'Zəhmət olmasa sertifikat seçin',
  selectCertificate: 'Sənədi imzalamaq üçün sertifikat seçin',
  documentNotReady: 'Sənəd məlumatı hazır deyil. Zəhmət olmasa səhifə yüklənənə qədər gözləyin, sonra imzalayın.',
  documentNotReadyNoSignerId: 'USB ilə imzalamaq üçün bu sənədi şəxsi imzalama linkinizlə açın (sizə göndərilən link). Bu səhifə imzalayıcı ID-niz olmadan açılıb.',
  serialNumber: 'Seriya Nömrəsi',
  sign: 'İmzala',
  missingDocumentInfo: 'Sənəd məlumatı yoxdur',
  failedToSignDocument: 'Sənədi imzalamaq mümkün olmadı',
  errorSigningDocument: 'Sənədi imzalamaqda xəta',
  failedToUploadSignedDocument: 'İmzalanmış sənədi yükləmək mümkün olmadı',
  errorSigningWithUsbToken: 'USB açarı ilə sənədi imzalamaqda xəta',

  signLinkStatusLabel: 'Status',
  signLinkStatusPending: 'İmza gözlənilir',
  signLinkStatusReleased: 'Təsdiqlənib (viza)',
  signLinkStatusUnknown: 'Naməlum status',
  signLinkHello: 'Salam,',
  signLinkPageTitleSigner: 'Sənədi imzalayın',
  signLinkPageTitleVisa: 'Sənədi təsdiqləyin',
  signLinkValidUntil: 'Etibarlıdır',
  signLinkSignedOn: 'Tarix',
  signLinkSignCta: 'Sima ilə imzala',
  signLinkVisaCta: 'Təsdiqləmək üçün daxil olun',
  signLinkVisaNotice:
    'Bu Viza tipli sənəddir. mySign-da açmaq və bir düymə ilə təsdiqləmək üçün daxil olun.',
  signLinkViewIntro: 'Sənədi brauzerdə görmək üçün mySign.az-da',
  signLinkLoginAction: 'daxil olun',
  signLinkViewOr: 'və ya',
  signLinkRegisterAction: 'qeydiyyatdan keçin',
  signLinkHowToSignTitle: 'Sima ilə necə imzalayıram?',
  signLinkHowToVisaTitle: 'Necə təsdiqləyirəm?',
  signLinkHowToStep1: 'Düyməyə toxunun və Sima tətbiqini açın.',
  signLinkHowToStep2: 'Tətbiqdə əməliyyatı tamamlayın. Kompüterdə QR kodu skan edin.',
  signLinkHowToStep3: 'Bu səhifə nəticəni özü göstərəcək.',
  signLinkContinueInSima: 'Sima-da davam edin',
  signLinkOpenSima: 'Sima tətbiqini aç',
  signLinkScanOtherDevice: 'Başqa cihazda skan edin',
  signLinkQrInstructions: 'QR kodu Sima tətbiqi ilə skan edin.',
  signLinkQrAlt: 'Sima üçün QR kod',
  signLinkPolling: 'İmza statusu yoxlanılır…',
  signLinkNotFoundTitle: 'Link tapılmadı',
  signLinkNotFoundBody: 'Bu link etibarsızdır və ya mövcud deyil. Sizə göndərilmiş dəvəti yenidən açın.',
  signLinkInvalidTitle: 'Link etibarsızdır',
  signLinkInvalidBody: 'Bu imza linki düzgün deyil. Yeni dəvət linkini açın.',
  signLinkLoadError: 'Məlumat yüklənmədi. Yenidən cəhd edin.',
  signLinkRetry: 'Yenidən cəhd et',
  signLinkLoading: 'Yüklənir',
  signLinkPrivacy: 'Məxfilik',
  signLinkFooterNav: 'Keçidlər',
  signLinkThanks: 'Təşəkkür edirik.',
  signLinkCompletedSigned: 'Sənəd imzalanıb.',
  signLinkCompletedReleased: 'Sənəd təsdiqlənib.',
  signLinkLockGeneric: 'Sənəd hazırda kilidlidir. Bir az sonra yenidən cəhd edin.',
  signLinkStartError: 'İmzalama başladılmadı. Yenidən cəhd edin.',
  signLinkBlockedHint: 'Hazırda imzalamaq mümkün deyil.',
  signLinkAlreadyUsed: 'Bu imzalama linki artıq istifadə olunub.',
};

